import { useStore } from "react-redux";
import { Redirect, RouteProps, Switch, useRouteMatch } from "react-router-dom";
import { RootState } from "maven-lib/dist/states";
import { HomeRoute } from "./routes/HomeRoute";
import { AuthRoute } from "@maven-surface/components/common/AuthRoute";

interface HomeLayoutProps extends RouteProps {}

export function HomeLayout(props: HomeLayoutProps) {
  const match = useRouteMatch();

  const session = useStore<RootState>().getState().session;

  return (
    <Switch>
      <AuthRoute session={session} authorizedOnly={false} denyRedirectTo="/pat/visits" path={`${match.url}`} component={HomeRoute} />
      <Redirect from="*" to="/404?r=wl" />
    </Switch>
  );
}
